"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4912],{

/***/ 79001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _hooks_useCheckUpdatingFile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91837);
/* harmony import */ var _components_common_Navigation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13442);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);




var PdfNavigation = function PdfNavigation() {
  var _useCheckUpdatingFile = (0,_hooks_useCheckUpdatingFile__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
      isDisabled = _useCheckUpdatingFile.isDisabled,
      handleDisabledButtonClick = _useCheckUpdatingFile.handleDisabledButtonClick;

  var NAVIGATION_NAMES = [{
    name: '열람 분석',
    icon: 'ph:chart-bar',
    route: '/user/pdf/activity-analysis',
    className: 'pdf-activity-analysis'
  }, {
    name: '고객 목록',
    icon: 'ph:users',
    route: '/user/pdf/tracking-clients',
    className: 'pdf-tracking-clients'
  }, {
    name: '뷰어 설정',
    icon: 'ph:gear-fine',
    route: '/user/pdf/share-setting',
    className: 'pdf-share-setting',
    isDisabled: isDisabled,
    onClick: handleDisabledButtonClick
  }];
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_common_Navigation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    navigations: NAVIGATION_NAMES
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PdfNavigation);

/***/ }),

/***/ 98538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FileUpload_Preview; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/User/_components/common/CreateFileModal/FileUpload/Preview/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ww13cn3"
} : 0)( true ? {
  name: "o2kg5k",
  styles: "position:relative;width:100%;&:not(:hover){.hover{opacity:0.25;}&>.hover{transition:opacity 0.15s ease-in-out;}}"
} : 0);
var FileNameWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ww13cn2"
} : 0)("position:absolute;z-index:", zIndex/* Z_INDEX.onTop */.k.onTop, ";top:8px;left:8px;padding:8px 12px;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";border-radius:4px;" + ( true ? "" : 0));
var ButtonFileChange = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e1ww13cn1"
} : 0)("position:absolute;z-index:", zIndex/* Z_INDEX.onTop */.k.onTop, ";top:50px;left:8px;" + ( true ? "" : 0));
var FlexPdfViewerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1ww13cn0"
} : 0)("position:relative;height:289px;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.zinc_400;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/CreateFileModal/FileUpload/Preview/index.tsx






var Preview = function Preview(_ref) {
  var file = _ref.file,
      filename = _ref.filename,
      onClickChangeFile = _ref.onClickChangeFile;
  var fileUrl = react.useMemo(function () {
    return URL.createObjectURL(file);
  }, [filename]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileNameWrapper, {
      className: "hover",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "md-medium",
        color: "zinc_400",
        children: filename
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonFileChange, {
      className: "hover",
      variant: "skyblue_400_fill",
      paddingY: 8,
      paddingX: 12,
      radius: 4,
      textVariant: "sm-regular",
      onClick: onClickChangeFile,
      children: "\uD30C\uC77C \uBCC0\uACBD"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlexPdfViewerWrapper, {
      justifyContent: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
        src: "".concat(fileUrl, "#toolbar=0&navpanes=0&scrollbar=0"),
        width: 530,
        height: 289
      })
    })]
  });
};

/* harmony default export */ var FileUpload_Preview = (/*#__PURE__*/react.memo(Preview));

/***/ }),

/***/ 1907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61810);
/* harmony import */ var _Tags_ComponentToolTip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73214);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52903);







var EmailCampaignSendButton = function EmailCampaignSendButton(_ref) {
  var targetType = _ref.targetType,
      targetId = _ref.targetId;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_Tags_ComponentToolTip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    description: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
      children: ["\uC774 \uCF58\uD150\uCE20\uB97C \uB0B4 \uC774\uBA54\uC77C \uC8FC\uC18C\uB85C \uACE0\uAC1D\uC5D0\uAC8C \uBC1C\uC1A1\uD558\uACE0", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("br", {}), "\uC804\uB2EC, \uC624\uD508, \uD074\uB9AD \uC5EC\uBD80\uB97C \uD655\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."]
    }),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
      variant: "skyblue_400",
      radius: 8,
      paddingX: 16,
      paddingY: 12,
      textVariant: "md-medium",
      width: "100%",
      leftIcon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: "ph:paper-plane-tilt",
        size: 17,
        color: "inherit"
      }),
      onClick: function onClick() {
        return router.push("/user/campaign/create?targetType=".concat(targetType, "&targetId=").concat(targetId));
      },
      children: "\uC774\uBA54\uC77C\uB85C \uBC1C\uC1A1\uD558\uAE30"
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (EmailCampaignSendButton);

/***/ }),

/***/ 39947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61810);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);





var NotFoundErrorModal = function NotFoundErrorModal(_ref) {
  var isModalOpen = _ref.isModalOpen,
      setModalOpen = _ref.setModalOpen;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var moveToMain = function moveToMain() {
    return router.replace('/user/pdf');
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Modal.Root */ .u_.Root, {
    open: isModalOpen,
    onOpenChange: function onOpenChange(open) {
      if (!open) {
        moveToMain();
      }

      setModalOpen(open);
    },
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Modal.Content */ .u_.Content, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Modal.Header */ .u_.Header, {
        title: "\uC811\uADFC\uD560 \uC218 \uC5C6\uB294 \uD398\uC774\uC9C0\uC785\uB2C8\uB2E4."
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Modal.Body */ .u_.Body, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
          children: "\uC874\uC7AC\uD558\uC9C0 \uC54A\uB294 \uD398\uC774\uC9C0 \uC785\uB2C8\uB2E4"
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Modal.Footer */ .u_.Footer, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Modal.Close */ .u_.Close, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .zx, {
            variant: "vermillion_400_fill",
            textVariant: "lg-regular",
            paddingX: 24,
            type: "button",
            onClick: function onClick() {
              moveToMain();
            },
            children: "\uD655\uC778"
          })
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (NotFoundErrorModal);

/***/ }),

/***/ 7446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pdf_BulkPdfInfoWithButtons; }
});

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(50381);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
// EXTERNAL MODULE: ../../packages/next-pdf-viewer/src/index.ts + 218 modules
var next_pdf_viewer_src = __webpack_require__(14242);
// EXTERNAL MODULE: ./hooks/queries/file/useFile.ts
var useFile = __webpack_require__(73037);
// EXTERNAL MODULE: ./utils/getUTCDate.ts + 1 modules
var getUTCDate = __webpack_require__(52497);
// EXTERNAL MODULE: ./components/User/_components/common/NotFoundErrorModal/index.tsx
var NotFoundErrorModal = __webpack_require__(39947);
// EXTERNAL MODULE: ./hooks/useShareUrl.ts
var useShareUrl = __webpack_require__(52650);
// EXTERNAL MODULE: ./components/User/_components/pdf/FileRelatedButtons/index.tsx + 4 modules
var FileRelatedButtons = __webpack_require__(62534);
;// CONCATENATED MODULE: ./utils/getEmailThumbnailLink.ts
var getEmailThumbnailLink = function getEmailThumbnailLink(_ref) {
  var thumbnailImgUrl = _ref.thumbnailImgUrl,
      title = _ref.title,
      link = _ref.link,
      totalCount = _ref.totalCount;
  return "<body style=\"display:inline-block; text-align: left;\">\n    <div style=\"height: 32px;\"></div>\n    <div style=\"display: block;align-items: center;margin: 0 auto;padding: 32px 32px;gap: 32px;width: 352px; height: auto;background: #FFFFFF;border: 1px solid #E4E4E7;border-radius: 8px;\">\n        <img class=\"thumbnail\" src=".concat(thumbnailImgUrl, " style=\"display:block;width: 320px;height: auto;margin:auto auto 16px auto;border-radius: 8px;\">\n        <h4 class=\"file-title\" style=\"width: 100%; margin:0 auto 0 auto;text-algin: center;line-break: anywhere;line-height: 125%;font-size: 20px;font-weight: 600; text-align:center;\">").concat(title, "</h4>\n        <p class=\"file-description\" style=\"width: 100%;text-align: center;line-break: anywhere;line-height: 125%;color: #b4b4b4;font-size: 14px;font-weight: 400;\">\uCD1D ").concat(totalCount, "\uD398\uC774\uC9C0</p>\n      <a style=\"display:block;border-radius: 8px;text-decoration: none;margin: 16px auto auto auto;padding: 16px 32px;gap: 8px;width: fit-content;height: auto;background: #6287A9;border: none;font-size: 16px;color: #ffffff; text-align:center;\" href=").concat(link, " target=\"_blank\">\n        \uCCA8\uBD80\uB41C \uD30C\uC77C \uD655\uC778\uD558\uAE30\n      </a>\n    </div>\n    <div class=\"email-margin\" style=\"height: 32px;\"></div>\n  </body>");
};

/* harmony default export */ var utils_getEmailThumbnailLink = (getEmailThumbnailLink);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/User/_components/pdf/EmailThumbnailModal/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var GrayContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1dps5jq3"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_50;
}, ";border-radius:8px;" + ( true ? "" : 0));
var WhiteContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1dps5jq2"
} : 0)("width:212px;border:1px solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.zinc_200;
}, ";background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, ";border-radius:8px;" + ( true ? "" : 0));
var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e1dps5jq1"
} : 0)( true ? {
  name: "1h3cbh4",
  styles: "white-space:pre-wrap;word-break:break-all"
} : 0);
var ImageContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dps5jq0"
} : 0)("position:relative;overflow:hidden;width:180px;height:102px;border:1px solid ", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.zinc_200;
}, ";border-radius:8px;" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/pdf/EmailThumbnailModal/index.tsx








var EmailThumbnailModal = function EmailThumbnailModal(_ref) {
  var isModalOpen = _ref.isModalOpen,
      setIsModalOpen = _ref.setIsModalOpen,
      title = _ref.title,
      thumbnailImgUrl = _ref.thumbnailImgUrl,
      link = _ref.link,
      totalCount = _ref.totalCount;
  var toast = (0,src/* useToast */.pm)();

  var handleEmailLinkCopyClick = function handleEmailLinkCopyClick() {
    var emailThumbnailUrl = utils_getEmailThumbnailLink({
      thumbnailImgUrl: thumbnailImgUrl,
      title: title,
      link: link,
      totalCount: totalCount
    });
    copy_to_clipboard_default()(emailThumbnailUrl, {
      format: 'text/html'
    });
    toast('복사되었습니다');
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Root */.u_.Root, {
    open: isModalOpen,
    onOpenChange: function onOpenChange(open) {
      setIsModalOpen(open);
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Modal.Content */.u_.Content, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Header */.u_.Header, {
        title: "\uC774\uBA54\uC77C\uC5D0 \uBD99\uC5EC\uB123\uAE30"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Body */.u_.Body, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 16,
          direction: "column",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
            justifyContent: "space-between",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
              variant: "md-semibold",
              color: "black",
              children: ["HTML \uCF54\uB4DC\uB97C \uBCF5\uC0AC\uD558\uC5EC", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC774\uBA54\uC77C \uBCF8\uBB38\uC5D0 \uBD99\uC5EC\uB123\uC73C\uC138\uC694."]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
              variant: "black_to_zinc_900",
              leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: "ph:image-square",
                size: 17,
                color: "inherit"
              }),
              radius: 8,
              paddingX: 16,
              paddingY: 12,
              textVariant: "md-medium",
              width: "fit-content",
              onClick: handleEmailLinkCopyClick,
              children: "\uC774\uBA54\uC77C \uCCA8\uBD80\uC6A9 HTML \uCF54\uB4DC \uBCF5\uC0AC\uD558\uAE30"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GrayContainer, {
            gap: 16,
            alignItems: "center",
            width: "100%",
            direction: "column",
            padding: 16,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WhiteContainer, {
              gap: 16,
              padding: 16,
              direction: "column",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
                gap: 8,
                direction: "column",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    src: thumbnailImgUrl,
                    layout: "fill"
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
                  gap: 4,
                  direction: "column",
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    variant: "md-semibold",
                    color: "black",
                    textAlign: "center",
                    children: title
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
                    variant: "xs-medium",
                    color: "zinc_400",
                    textAlign: "center",
                    children: ["\uCD1D ", totalCount, " \uD398\uC774\uC9C0"]
                  })]
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
                variant: "skyblue_500_fill",
                textVariant: "sm-semibold",
                paddingX: 16,
                paddingY: 12,
                children: "\uCCA8\uBD80\uB41C \uD30C\uC77C \uD655\uC778\uD558\uAE30"
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-medium",
              color: "zinc_400",
              textAlign: "center",
              children: "\uC704\uC640 \uAC19\uC774 \uC774\uBA54\uC77C\uC5D0 \uCCA8\uBD80\uB429\uB2C8\uB2E4"
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var pdf_EmailThumbnailModal = (EmailThumbnailModal);
// EXTERNAL MODULE: ./components/User/_components/common/Tags/ComponentToolTip/index.tsx + 1 modules
var ComponentToolTip = __webpack_require__(73214);
// EXTERNAL MODULE: ./components/User/_components/common/EmailCampaignSendButton/index.tsx
var EmailCampaignSendButton = __webpack_require__(1907);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../packages/next-pdf-viewer/src/constant/formValidations.ts
var formValidations = __webpack_require__(31084);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 1 modules
var useQuery = __webpack_require__(7040);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/queries/file/useFileIndividualList.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var getFileIndividualList = function getFileIndividualList(_ref) {
  var fileId = _ref.fileId;
  return api/* api.get */.h.get('/v2/file/individual', {
    params: {
      fileId: fileId
    }
  });
};

var useFileIndividualList = function useFileIndividualList(request, options) {
  return (0,useQuery/* useQuery */.a)(['getFileIndividualList', request], function () {
    return getFileIndividualList(request);
  }, _objectSpread({}, options));
};

/* harmony default export */ var file_useFileIndividualList = (useFileIndividualList);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
;// CONCATENATED MODULE: ./hooks/mutations/file/useCreateIndividualLink.ts


function useCreateIndividualLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useCreateIndividualLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useCreateIndividualLink_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useCreateIndividualLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var createIndividualLink = function createIndividualLink(_ref) {
  var fileId = _ref.fileId,
      email = _ref.email;
  return api/* api.post */.h.post('/v2/file/individual', {
    fileId: fileId,
    email: email
  });
};

var useCreateIndividualLink = function useCreateIndividualLink(options) {
  return (0,useMutation/* useMutation */.D)(createIndividualLink, useCreateIndividualLink_objectSpread({}, options));
};

/* harmony default export */ var file_useCreateIndividualLink = (useCreateIndividualLink);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkPdfInfoWithButtons/OneToOneLinkGenerateButton/OneToOneLinkGenerateModal/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var InputWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e194l6gt1"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
var CreateButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e194l6gt0"
} : 0)( true ? {
  name: "3m7n3k",
  styles: "height:fit-content;flex-grow:1;flex-shrink:0"
} : 0);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(752);
// EXTERNAL MODULE: ./utils/shareLink.ts
var shareLink = __webpack_require__(79629);
// EXTERNAL MODULE: ./state/user/atom.ts
var atom = __webpack_require__(37271);
;// CONCATENATED MODULE: ./hooks/mutations/file/useDeleteIndividualLink.ts


function useDeleteIndividualLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useDeleteIndividualLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useDeleteIndividualLink_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useDeleteIndividualLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deleteIndividualLink = function deleteIndividualLink(_ref) {
  var fileId = _ref.fileId,
      hash = _ref.hash;
  return api/* api.delete */.h["delete"]('/v2/file/individual', {
    params: {
      fileId: fileId,
      hash: hash
    }
  });
};

var useDeleteIndividualLink = function useDeleteIndividualLink(options) {
  return (0,useMutation/* useMutation */.D)(deleteIndividualLink, useDeleteIndividualLink_objectSpread({}, options));
};

/* harmony default export */ var file_useDeleteIndividualLink = (useDeleteIndividualLink);
// EXTERNAL MODULE: ./hooks/queries/share/useShortShareToken.ts
var useShortShareToken = __webpack_require__(52299);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkPdfInfoWithButtons/OneToOneLinkGenerateButton/OneToOneLinkGenerateModal/OneToOneLinkList/OneToOneLinkItem/index.styles.ts


function OneToOneLinkItem_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e15apz4r4"
} : 0)("border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";border-radius:8px;" + ( true ? "" : 0));
var LinkBlueWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e15apz4r3"
} : 0)("width:100%;justify-content:space-between;padding:16px;background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.skyblue_50;
}, ";border-radius:8px;&:hover{background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.skyblue_100;
}, ";cursor:pointer;}" + ( true ? "" : 0));
var LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e15apz4r2"
} : 0)( true ? {
  name: "1h2azu3",
  styles: "overflow:hidden;width:fit-content;text-overflow:ellipsis;white-space:nowrap"
} : 0);
var LinkDeleteButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "e15apz4r1"
} : 0)( true ? {
  name: "y176lw",
  styles: "height:fit-content;flex-shrink:0"
} : 0);
var CopyButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e15apz4r0"
} : 0)("display:flex;width:fit-content;flex-grow:1;flex-shrink:0;align-items:center;justify-content:flex-end;margin-left:16px;color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.skyblue_600;
}, ";gap:8px;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkPdfInfoWithButtons/OneToOneLinkGenerateButton/OneToOneLinkGenerateModal/OneToOneLinkList/OneToOneLinkItem/index.tsx






var OneToOneLinkItem = function OneToOneLinkItem(_ref) {
  var email = _ref.email,
      link = _ref.link,
      handleLinkDelete = _ref.handleLinkDelete;
  var toast = (0,src/* useToast */.pm)();

  var handleLinkCopy = function handleLinkCopy() {
    copy_to_clipboard_default()(link);
    toast('링크가 복사되었습니다');
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
    width: "100%",
    gap: 16,
    padding: 16,
    direction: "column",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
      justifyContent: "space-between",
      alignItems: "flex-start",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 4,
        direction: "column",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "sm-medium",
          color: "zinc_400",
          children: "\uC774\uBA54\uC77C"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "md-medium",
          children: email
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkDeleteButton, {
        variant: "cerise_100",
        paddingX: 8,
        paddingY: 4,
        radius: 4,
        leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:trash",
          color: "inherit",
          size: 17
        }),
        onClick: handleLinkDelete,
        children: "\uC228\uAE40"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 4,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "sm-medium",
        color: "zinc_400",
        children: "\uACF5\uC720\uB9C1\uD06C"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkBlueWrapper, {
        alignItems: "center",
        onClick: handleLinkCopy,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
          variant: "sm-medium",
          color: "skyblue_600",
          children: link
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyButtonWrapper, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:copy",
            size: 17,
            color: "inherit"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            color: "inherit",
            children: "\uBCF5\uC0AC\uD558\uAE30"
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var OneToOneLinkList_OneToOneLinkItem = (OneToOneLinkItem);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkPdfInfoWithButtons/OneToOneLinkGenerateButton/OneToOneLinkGenerateModal/OneToOneLinkList/index.styles.ts


function OneToOneLinkList_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lfrsia0"
} : 0)( true ? {
  name: "1rtuqbz",
  styles: "height:fit-content;max-height:345px;overflow-y:scroll;::-webkit-scrollbar{width:0;visibility:hidden;}"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkPdfInfoWithButtons/OneToOneLinkGenerateButton/OneToOneLinkGenerateModal/OneToOneLinkList/index.tsx











var OneToOneLinkList = function OneToOneLinkList(_ref) {
  var fileId = _ref.fileId,
      individualLinkList = _ref.individualLinkList,
      refetchIndividualLinkList = _ref.refetchIndividualLinkList;
  var userInfo = (0,esm_react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);
  /* 목록은 URL을 텍스트로 보여주므로 수신자 수만큼 토큰이 미리 있어야 한다.
     발급 API는 멱등이고 응답은 캐시되므로 목록을 다시 열어도 재요청하지 않는다. */

  var tokenQueries = (0,useShortShareToken/* useShortShareTokens */.hE)(individualLinkList.map(function (_ref2) {
    var hashForShare = _ref2.hashForShare;
    return {
      targetType: 'BULK_FILE_INDIVIDUAL',
      hash: hashForShare
    };
  }));

  var _useDeleteIndividualL = file_useDeleteIndividualLink({
    onSuccess: function onSuccess() {
      refetchIndividualLinkList();
    }
  }),
      deleteLink = _useDeleteIndividualL.mutate;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 16,
    direction: "column",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "md-semibold",
      color: "black",
      children: "\uB0B4\uAC00 \uC0DD\uC131\uD55C 1:1 \uACF5\uC720\uC6A9 \uB9C1\uD06C \uBAA9\uB85D"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_styles_Container, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kq, {
        gap: 8,
        direction: "column",
        children: individualLinkList.map(function (_ref3, index) {
          var _tokenQueries$index;

          var email = _ref3.email,
              hash = _ref3.hash,
              hashForShare = _ref3.hashForShare;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneToOneLinkList_OneToOneLinkItem, {
            email: email,
            link: (_tokenQueries$index = tokenQueries[index]) !== null && _tokenQueries$index !== void 0 && _tokenQueries$index.data ? (0,shareLink/* getShortShareLink */.qB)({
              token: tokenQueries[index].data,
              domain: userInfo === null || userInfo === void 0 ? void 0 : userInfo.domain
            }) : (0,shareLink/* getFileShareLink */.c0)({
              hashId: hashForShare,
              isBulk: true,
              domain: userInfo === null || userInfo === void 0 ? void 0 : userInfo.domain
            }),
            handleLinkDelete: function handleLinkDelete() {
              deleteLink({
                fileId: fileId,
                hash: hash
              });
            }
          }, hash);
        })
      })
    })]
  });
};

/* harmony default export */ var OneToOneLinkGenerateModal_OneToOneLinkList = (OneToOneLinkList);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkPdfInfoWithButtons/OneToOneLinkGenerateButton/OneToOneLinkGenerateModal/index.tsx


function OneToOneLinkGenerateModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OneToOneLinkGenerateModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OneToOneLinkGenerateModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OneToOneLinkGenerateModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var OneToOneLinkGenerateModal = function OneToOneLinkGenerateModal(_ref) {
  var fileId = _ref.fileId,
      isModalOpen = _ref.isModalOpen,
      setIsModalOpen = _ref.setIsModalOpen;
  var toast = (0,src/* useToast */.pm)();

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'all'
  }),
      register = _useForm.register,
      getValues = _useForm.getValues,
      resetField = _useForm.resetField,
      _useForm$formState = _useForm.formState,
      isValid = _useForm$formState.isValid,
      errors = _useForm$formState.errors;

  var _useFileIndividualLis = file_useFileIndividualList({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    select: function select(data) {
      return data.data.data;
    }
  }),
      data = _useFileIndividualLis.data,
      refetch = _useFileIndividualLis.refetch;

  var _useCreateIndividualL = file_useCreateIndividualLink({
    onSuccess: function onSuccess() {
      refetch();
      resetField('userEmail');
      toast('링크가 생성되었습니다.');
    }
  }),
      createIndividualLink = _useCreateIndividualL.mutate;

  var handleCreateIndividualLink = function handleCreateIndividualLink() {
    createIndividualLink({
      fileId: fileId,
      email: getValues('userEmail')
    });
  };

  var checkUserEmailInputDuplicate = function checkUserEmailInputDuplicate(value) {
    if (data) {
      var duplicateItem = data.find(function (item) {
        return item.email === value;
      });

      if (typeof duplicateItem !== 'undefined') {
        return '이미 링크가 생성된 이메일입니다';
      }
    }

    return true;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Root */.u_.Root, {
    open: isModalOpen,
    onOpenChange: function onOpenChange(open) {
      setIsModalOpen(open);
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Modal.Content */.u_.Content, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Header */.u_.Header, {
        title: "1:1 \uACF5\uC720\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Body */.u_.Body, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 16,
          direction: "column",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "md-semibold",
            children: "\uD30C\uC77C\uC744 \uACF5\uC720\uBC1B\uC744 \uBD84\uC758 \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
            gap: 8,
            width: "100%",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InputWrapper, {
              direction: "column",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, OneToOneLinkGenerateModal_objectSpread({
                width: "100%",
                type: "email",
                isError: Boolean(errors.userEmail)
              }, register('userEmail', {
                pattern: {
                  value: formValidations/* FORM_VALIDATIONS.email.pattern.value */.R.email.pattern.value,
                  message: '올바른 이메일 형식을 입력해주세요'
                },
                required: true,
                validate: checkUserEmailInputDuplicate
              }))), errors.userEmail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
                errors: errors,
                name: "userEmail"
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateButton, {
              variant: "skyblue_300",
              paddingX: 16,
              paddingY: 8,
              disabled: !isValid,
              width: "fit-content",
              onClick: handleCreateIndividualLink,
              leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: "ph:link",
                color: "inherit",
                size: 17
              }),
              children: "1:1 \uC804\uB2EC\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
            })]
          }), data && data.length >= 1 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneToOneLinkGenerateModal_OneToOneLinkList, {
            fileId: fileId,
            individualLinkList: data,
            refetchIndividualLinkList: function refetchIndividualLinkList() {
              return refetch();
            }
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var OneToOneLinkGenerateButton_OneToOneLinkGenerateModal = (OneToOneLinkGenerateModal);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkPdfInfoWithButtons/OneToOneLinkGenerateButton/index.tsx








var OneToOneLinkGenerateButton = function OneToOneLinkGenerateButton(_ref) {
  var fileId = _ref.fileId;

  var _useState = (0,react.useState)(false),
      isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComponentToolTip/* default */.Z, {
      description: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: ["1:1 \uBC1C\uC1A1\uC6A9 \uB9C1\uD06C\uB97C \uB9CC\uB4E4\uBA74 \uC0C1\uB300\uBC29\uC774 \uC774\uBA54\uC77C\uC774\uB098 \uB2E4\uB978 \uC815\uBCF4\uB97C \uC785\uB825\uD558\uC9C0 \uC54A\uC544\uB3C4", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uACE0\uAC1D\uC758 \uC5F4\uB78C \uC5EC\uBD80\uB97C \uD30C\uC545\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."]
      }),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        variant: "skyblue_400",
        radius: 8,
        paddingX: 16,
        paddingY: 12,
        textVariant: "md-medium",
        width: "100%",
        leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:user",
          size: 17,
          color: "inherit"
        }),
        onClick: function onClick() {
          return setIsModalOpen(true);
        },
        children: "1:1 \uACF5\uC720\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneToOneLinkGenerateButton_OneToOneLinkGenerateModal, {
      fileId: fileId,
      isModalOpen: isModalOpen,
      setIsModalOpen: setIsModalOpen
    })]
  });
};

/* harmony default export */ var BulkPdfInfoWithButtons_OneToOneLinkGenerateButton = (OneToOneLinkGenerateButton);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkPdfInfoWithButtons/index.tsx



















var BulkPdfInfoWithButtons = function BulkPdfInfoWithButtons() {
  var _data$file$hashId, _data$file$pages, _data$file;

  var router = (0,next_router.useRouter)();
  var toast = (0,src/* useToast */.pm)();
  var fileId = Number(router.query.fileId);

  var _useState = (0,react.useState)(false),
      isNotFoundModalOpen = _useState[0],
      setIsNotFoundModalOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isEmailThumbnailModalOpen = _useState2[0],
      setIsEmailThumbnailModalOpen = _useState2[1];

  var _useFile = (0,useFile/* default */.Z)({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    select: function select(data) {
      return data.data.data;
    },
    onError: function onError(error) {
      var _error$response;

      if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404) {
        setIsNotFoundModalOpen(true);
      }
    },
    retry: 1
  }),
      data = _useFile.data;

  var _useShareUrl = (0,useShareUrl/* default */.Z)({
    targetType: 'BULK_FILE',
    identifier: (_data$file$hashId = data === null || data === void 0 ? void 0 : data.file.hashId) !== null && _data$file$hashId !== void 0 ? _data$file$hashId : ''
  }),
      shareUrl = _useShareUrl.url;

  var handleBulkViewerUrlCopy = function handleBulkViewerUrlCopy() {
    if (data !== null && data !== void 0 && data.file.hashId) {
      copy_to_clipboard_default()(shareUrl);
      toast('링크가 복사되었습니다.');
      return;
    }

    toast.error("\uACF5\uC720 \uB9C1\uD06C\uB97C \uBCF5\uC0AC\uD558\uB294\uB370 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.\n\uC0C8\uB85C\uACE0\uCE68 \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.");
  };

  var handleOpenQrView = function handleOpenQrView() {
    if (!(data !== null && data !== void 0 && data.file.hashId)) {
      toast.error("\uACF5\uC720 \uB9C1\uD06C\uAC00 \uC544\uC9C1 \uC0DD\uC131\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.\n\uC0C8\uB85C\uACE0\uCE68 \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.");
      return;
    }

    window.open("/user/qr?type=file&id=".concat(fileId), '_blank', 'noreferrer noopener');
  };

  if (!(data !== null && data !== void 0 && data.file)) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {});
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Box */.xu, {
      isTitleImage: true,
      isMultipleCTAButtons: true,
      title: data.file.imageSources ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_pdf_viewer_src/* PdfThumbImage */.It, {
        thumb: data.file.imageSources.thumb,
        alt: data.file.name,
        fill: true,
        objectFit: "cover"
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: data.file.thumnail,
        layout: "fill",
        objectFit: "cover"
      }),
      bottomCTAButton: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 8,
        direction: "column",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileRelatedButtons/* default */.Z, {
          fileId: fileId,
          fileName: data.file.name,
          fileThumbnail: data.file.thumnail
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          direction: "column",
          gap: 8,
          width: "100%",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComponentToolTip/* default */.Z, {
            description: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: ["\uD648\uD398\uC774\uC9C0\xB7SNS \uB4F1 \uB204\uAD6C\uB098 \uC811\uADFC\uD560 \uC218 \uC788\uB294 \uACF3\uC5D0 \uACF5\uC720\uD560 \uB54C ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC0AC\uC6A9\uD558\uC138\uC694. \uBB38\uC758 \uC591\uC2DD\uC744 \uC81C\uCD9C\uD558\uAE30 \uC804 \uAE4C\uC9C0 \uC775\uBA85\uC73C\uB85C \uC9D1\uACC4\uB429\uB2C8\uB2E4."]
            }),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
              variant: "black_to_zinc_900",
              leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: "ph:link",
                size: 17,
                color: "inherit"
              }),
              radius: 8,
              paddingX: 22,
              paddingY: 12,
              textVariant: "md-medium",
              onClick: handleBulkViewerUrlCopy,
              width: "100%",
              className: 'share-link-button',
              children: "\uACF5\uC720 \uB9C1\uD06C \uBCF5\uC0AC\uD558\uAE30"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComponentToolTip/* default */.Z, {
            description: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: ["\uD589\uC0AC\uC7A5\xB7\uBD80\uC2A4 \uBAA8\uB2C8\uD130\uB098 \uB178\uD2B8\uBD81 \uD654\uBA74\uC5D0 QR \uCF54\uB4DC\uB97C \uB744\uC6CC\uB450\uACE0,", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uBC29\uBB38\uC790\uAC00 \uC2A4\uCE94\uD574 \uBC14\uB85C \uC790\uB8CC\uB97C \uD655\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. QR\uB85C \uB4E4\uC5B4\uC628", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC5F4\uB78C\uC740 UTM \uCEA0\uD398\uC778 \uC131\uACFC\uC5D0\uC11C \uAD6C\uBD84\uB429\uB2C8\uB2E4."]
            }),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
              variant: "skyblue_400",
              radius: 8,
              paddingX: 16,
              paddingY: 12,
              textVariant: "md-medium",
              leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: "ph:qr-code",
                size: 17,
                color: "inherit"
              }),
              onClick: handleOpenQrView,
              width: "100%",
              children: "QR \uCF54\uB4DC \uBCF4\uAE30"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
            variant: "skyblue_400",
            radius: 8,
            paddingX: 16,
            paddingY: 12,
            textVariant: "md-medium",
            leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:image-square",
              size: 17,
              color: "inherit"
            }),
            onClick: function onClick() {
              return setIsEmailThumbnailModalOpen(true);
            },
            children: "\uC774\uBA54\uC77C\uC5D0 \uBD99\uC5EC\uB123\uAE30"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkPdfInfoWithButtons_OneToOneLinkGenerateButton, {
            fileId: fileId
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCampaignSendButton/* default */.Z, {
            targetType: "FILE",
            targetId: fileId
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
            gap: 4,
            alignItems: "flex-start",
            justifyContent: 'flex-start',
            direction: "row",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
              width: 'fit-content',
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: "ph:info",
                size: 16,
                color: "zinc_400"
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
              variant: "sm-medium",
              color: "zinc_400",
              children: ["\uD648\uD398\uC774\uC9C0\xB7SNS \uAC8C\uC2DC\uB294 ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                children: "\uACF5\uC720 \uB9C1\uD06C"
              }), ",", '\n', "\uC774\uBA54\uC77C \uB4F1 \uD2B9\uC815 \uACE0\uAC1D\uC5D0\uAC8C \uBCF4\uB0BC \uB550 ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                children: "1:1 \uACF5\uC720\uC6A9 \uB9C1\uD06C"
              }), "\uB97C \uC0AC\uC6A9\uD558\uC138\uC694."]
            })]
          })]
        })]
      }),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        as: "p",
        variant: "lg-semibold",
        children: data.file.name
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        as: "p",
        variant: "sm-medium",
        color: "zinc_400",
        marginTop: 4,
        children: data.file.editedAt ? "".concat((0,getUTCDate/* getUTCDate */.E)(data.file.editedAt, 'yearMonthDay'), " \uC218\uC815\uB428") : "".concat((0,getUTCDate/* getUTCDate */.E)(data.file.createdAt, 'yearMonthDay'), " \uC0DD\uC131\uB428")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Tag */.Vp, {
        variant: "loyalblue_50",
        marginTop: 8,
        textVariant: "md-medium",
        children: "\uB300\uB7C9\uBC1C\uC1A1\uC6A9"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotFoundErrorModal/* default */.Z, {
      isModalOpen: isNotFoundModalOpen,
      setModalOpen: setIsNotFoundModalOpen
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pdf_EmailThumbnailModal, {
      isModalOpen: isEmailThumbnailModalOpen,
      setIsModalOpen: setIsEmailThumbnailModalOpen,
      thumbnailImgUrl: data.file.thumnail,
      title: data.file.name,
      link: shareUrl,
      totalCount: (_data$file$pages = (_data$file = data.file) === null || _data$file === void 0 ? void 0 : _data$file.pages) !== null && _data$file$pages !== void 0 ? _data$file$pages : 0
    })]
  });
};

/* harmony default export */ var pdf_BulkPdfInfoWithButtons = (BulkPdfInfoWithButtons);

/***/ }),

/***/ 19743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61810);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _pairy_next_pdf_viewer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14242);
/* harmony import */ var _hooks_queries_file_useFile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73037);
/* harmony import */ var _utils_getUTCDate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52497);
/* harmony import */ var _components_User_components_common_NotFoundErrorModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39947);
/* harmony import */ var _FileRelatedButtons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52903);













var PdfInfoWithButtons = function PdfInfoWithButtons() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  var fileId = Number(router.query.fileId);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isNotFoundModalOpen = _useState[0],
      setIsNotFoundModalOpen = _useState[1];

  var _useFile = (0,_hooks_queries_file_useFile__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    select: function select(data) {
      return data.data.data.file;
    },
    onError: function onError(error) {
      var _error$response;

      if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404) {
        setIsNotFoundModalOpen(true);
      }
    },
    retry: 1
  }),
      fileData = _useFile.data;

  if (!fileData) {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {});
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
      isTitleImage: true,
      isMultipleCTAButtons: true,
      title: fileData.imageSources ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_pairy_next_pdf_viewer__WEBPACK_IMPORTED_MODULE_4__/* .PdfThumbImage */ .It, {
        thumb: fileData.imageSources.thumb,
        alt: fileData.name,
        fill: true,
        objectFit: "cover"
      }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
        src: fileData.thumnail,
        layout: "fill",
        objectFit: "cover"
      }),
      bottomCTAButton: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_FileRelatedButtons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        fileId: fileId,
        fileName: fileData.name,
        fileThumbnail: fileData.thumnail
      }),
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
        as: "p",
        variant: "lg-semibold",
        children: fileData.name
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
        as: "p",
        variant: "sm-medium",
        color: "zinc_400",
        marginTop: 4,
        children: fileData.editedAt ? "".concat((0,_utils_getUTCDate__WEBPACK_IMPORTED_MODULE_6__/* .getUTCDate */ .E)(fileData.editedAt, 'yearMonthDay'), " \uC218\uC815\uB428") : "".concat((0,_utils_getUTCDate__WEBPACK_IMPORTED_MODULE_6__/* .getUTCDate */ .E)(fileData.createdAt, 'yearMonthDay'), " \uC0DD\uC131\uB428")
      }), fileData.isBulk && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_pairy_pds_react__WEBPACK_IMPORTED_MODULE_2__/* .Tag */ .Vp, {
        variant: "loyalblue_50",
        marginTop: 8,
        textVariant: "md-medium",
        children: "\uB300\uB7C9\uBC1C\uC1A1\uC6A9"
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_User_components_common_NotFoundErrorModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      isModalOpen: isNotFoundModalOpen,
      setModalOpen: setIsNotFoundModalOpen
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PdfInfoWithButtons);

/***/ }),

/***/ 73037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getFile */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7040);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getFile = function getFile(_ref) {
  var fileId = _ref.fileId;
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.get */ .h.get("/file", {
    params: {
      fileId: fileId
    }
  });
};

var useFile = function useFile(request, options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(['getFile', request], function () {
    return getFile(request);
  }, _objectSpread({}, options));
};

/* harmony default export */ __webpack_exports__["Z"] = (useFile);

/***/ }),

/***/ 52299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PE": function() { return /* binding */ patchShortShareTokenCache; },
/* harmony export */   "QB": function() { return /* binding */ shortShareTokenQueryKey; },
/* harmony export */   "Qs": function() { return /* binding */ issueShortShareToken; },
/* harmony export */   "hE": function() { return /* binding */ useShortShareTokens; },
/* harmony export */   "zB": function() { return /* binding */ pickShareAlias; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7040);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52308);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




/** `/s/` 뒤에 붙일 값. 커스텀 주소가 있으면 그것이 대표 URL 이다(기획서 §22). */
var pickShareAlias = function pickShareAlias(_ref) {
  var token = _ref.token,
      customSlug = _ref.customSlug;
  return customSlug !== null && customSlug !== void 0 ? customSlug : token;
};
var issueShortShareToken = function issueShortShareToken(_ref2) {
  var targetType = _ref2.targetType,
      hash = _ref2.hash;
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.post */ .h.post('/v2/share/short-link', {
    targetType: targetType,
    hash: hash
  });
};
var shortShareTokenQueryKey = function shortShareTokenQueryKey(request) {
  return ['getShortShareToken', request];
};
/** 대상이 없거나 권한이 없는 응답은 재시도해도 결과가 같다 */

var NON_RETRYABLE_STATUS = [400, 403, 404];

var retryShortShareToken = function retryShortShareToken(failureCount, error) {
  var _response$status, _response;

  var status = (_response$status = error === null || error === void 0 ? void 0 : (_response = error.response) === null || _response === void 0 ? void 0 : _response.status) !== null && _response$status !== void 0 ? _response$status : 0;
  return failureCount < 1 && !NON_RETRYABLE_STATUS.includes(status);
};
/**
 * 단축 링크 토큰을 발급받는다. 발급 API는 멱등이라 같은 대상은 항상 같은 토큰이 오므로
 * 캐시해두고 다시 부르지 않는다.
 *
 * mutation이 아니라 query인 이유: 클립보드 복사는 사용자 제스처와 같은 태스크에서
 * 동기적으로 일어나야 한다(Safari). 클릭 핸들러 안에서 await 하면 복사가 실패하므로
 * 렌더 시점에 미리 받아두고 클릭할 때는 값만 읽는다.
 */


var useShortShareToken = function useShortShareToken(request, options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(shortShareTokenQueryKey(request), function () {
    return issueShortShareToken(request);
  }, _objectSpread({
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: Boolean(request.hash),
    retry: retryShortShareToken
  }, options));
};
/**
 * 커스텀 링크 설정/해제 응답을 발급 캐시에 즉시 반영한다.
 *
 * invalidateQueries 가 아닌 이유: staleTime 이 Infinity 라 invalidate 는 곧바로 재발급을
 * 부르고, 무엇보다 복사 버튼은 렌더 시점에 URL 이 확정돼 있어야 한다(Safari 제약).
 * 설정/해제 API 가 이미 권위 있는 값을 돌려주므로 그대로 덮어쓰는 편이 맞다.
 */


var patchShortShareTokenCache = function patchShortShareTokenCache(queryClient, request, patch) {
  queryClient.setQueryData(shortShareTokenQueryKey(request), function (previous) {
    return previous && _objectSpread(_objectSpread({}, previous), {}, {
      data: _objectSpread(_objectSpread({}, previous.data), {}, {
        data: _objectSpread(_objectSpread({}, previous.data.data), patch)
      })
    });
  });
};
/** 1:1 링크 목록처럼 여러 대상의 토큰이 한 번에 필요할 때 */

var useShortShareTokens = function useShortShareTokens(requests, options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQueries */ .h)({
    queries: requests.map(function (request) {
      var _options$enabled;

      return {
        queryKey: shortShareTokenQueryKey(request),
        queryFn: function queryFn() {
          return issueShortShareToken(request);
        },
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: ((_options$enabled = options === null || options === void 0 ? void 0 : options.enabled) !== null && _options$enabled !== void 0 ? _options$enabled : true) && Boolean(request.hash),
        retry: retryShortShareToken,
        select: function select(data) {
          return data.data.data.token;
        }
      };
    })
  });
};
/* harmony default export */ __webpack_exports__["ZP"] = (useShortShareToken);

/***/ }),

/***/ 52650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export buildLongShareUrl */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(752);
/* harmony import */ var _utils_shareLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79629);
/* harmony import */ var _state_user_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37271);
/* harmony import */ var _hooks_queries_share_useShortShareToken__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52299);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






/** 단축 토큰을 못 받았을 때 폴백으로 쓰는 기존 공유 URL */
var buildLongShareUrl = function buildLongShareUrl(_ref) {
  var targetType = _ref.targetType,
      identifier = _ref.identifier,
      domain = _ref.domain;

  switch (targetType) {
    case 'BULK_FILE':
    case 'BULK_FILE_INDIVIDUAL':
      return (0,_utils_shareLink__WEBPACK_IMPORTED_MODULE_1__/* .getFileShareLink */ .c0)({
        hashId: identifier,
        isBulk: true,
        domain: domain
      });

    case 'CLIENT_FILE':
      return (0,_utils_shareLink__WEBPACK_IMPORTED_MODULE_1__/* .getFileShareLink */ .c0)({
        hashId: identifier,
        isBulk: false,
        domain: domain
      });

    case 'BULK_LINK':
      return (0,_utils_shareLink__WEBPACK_IMPORTED_MODULE_1__/* .getBulkLinkShareLink */ .sm)({
        slug: identifier,
        domain: domain
      });

    case 'CLIENT_LINK':
      return (0,_utils_shareLink__WEBPACK_IMPORTED_MODULE_1__/* .getLinkShareLink */ .OM)({
        hashId: identifier,
        domain: domain
      });

    default:
      return '';
  }
};

/**
 * 공유 링크 URL. 단축 토큰이 준비돼 있으면 `/s/{token}`, 아니면 기존 긴 URL을 준다.
 *
 * 토큰을 렌더 시점에 미리 받아두므로 복사 버튼은 클릭 핸들러에서 await 없이
 * 동기적으로 복사할 수 있다. 발급이 실패하거나 아직 도착하지 않았더라도 기존 URL이
 * 그대로 동작하므로 복사가 실패하는 경우는 없다.
 */
var useShareUrl = function useShareUrl(_ref2) {
  var _shareInfo$customSlug, _shareInfo$customizeD;

  var targetType = _ref2.targetType,
      identifier = _ref2.identifier,
      shortToken = _ref2.shortToken,
      _ref2$enabled = _ref2.enabled,
      enabled = _ref2$enabled === void 0 ? true : _ref2$enabled;
  var userInfo = (0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtomValue */ .Dv)(_state_user_atom__WEBPACK_IMPORTED_MODULE_2__/* .userInfoAtom */ .w);
  var domain = userInfo === null || userInfo === void 0 ? void 0 : userInfo.domain;

  var _useShortShareToken = (0,_hooks_queries_share_useShortShareToken__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
    targetType: targetType,
    hash: identifier
  }, {
    enabled: enabled && Boolean(identifier) && !shortToken,
    select: function select(data) {
      return data.data.data;
    }
  }),
      shareInfo = _useShortShareToken.data,
      isInitialLoading = _useShortShareToken.isInitialLoading;
  /* shortToken 경로는 발급 쿼리가 꺼져 있어 customSlug를 모르지만, 갓 만든 링크에는
     커스텀 주소가 있을 수 없으므로 문제되지 않는다. */


  var alias = shortToken !== null && shortToken !== void 0 ? shortToken : shareInfo ? (0,_hooks_queries_share_useShortShareToken__WEBPACK_IMPORTED_MODULE_3__/* .pickShareAlias */ .zB)(shareInfo) : undefined;
  var customLink = {
    customSlug: (_shareInfo$customSlug = shareInfo === null || shareInfo === void 0 ? void 0 : shareInfo.customSlug) !== null && _shareInfo$customSlug !== void 0 ? _shareInfo$customSlug : null,
    canCustomize: shareInfo === null || shareInfo === void 0 ? void 0 : shareInfo.canCustomize,
    customizeDeniedReason: (_shareInfo$customizeD = shareInfo === null || shareInfo === void 0 ? void 0 : shareInfo.customizeDeniedReason) !== null && _shareInfo$customizeD !== void 0 ? _shareInfo$customizeD : null
  };
  /* 발급이 끝나지 않았어도 기존 URL을 돌려준다. QR처럼 확정된 URL이 필요한 곳만
     isLoading 을 보고 기다리면 된다. */

  var isLoading = isInitialLoading;

  if (!identifier) {
    return _objectSpread({
      url: '',
      isShort: false,
      isLoading: false
    }, customLink);
  }

  if (alias) {
    return _objectSpread({
      url: (0,_utils_shareLink__WEBPACK_IMPORTED_MODULE_1__/* .getShortShareLink */ .qB)({
        token: alias,
        domain: domain
      }),
      isShort: true,
      isLoading: false
    }, customLink);
  }

  return _objectSpread({
    url: buildLongShareUrl({
      targetType: targetType,
      identifier: identifier,
      domain: domain
    }),
    isShort: false,
    isLoading: isLoading
  }, customLink);
};

/* harmony default export */ __webpack_exports__["Z"] = (useShareUrl);

/***/ }),

/***/ 79629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IV": function() { return /* binding */ getViewerOrigin; },
/* harmony export */   "OM": function() { return /* binding */ getLinkShareLink; },
/* harmony export */   "QW": function() { return /* binding */ createQrShareUrl; },
/* harmony export */   "c0": function() { return /* binding */ getFileShareLink; },
/* harmony export */   "j_": function() { return /* binding */ appendQuerySuffix; },
/* harmony export */   "qB": function() { return /* binding */ getShortShareLink; },
/* harmony export */   "sm": function() { return /* binding */ getBulkLinkShareLink; }
/* harmony export */ });
/* unused harmony export QR_UTM */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8529);
/* harmony import */ var _pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89608);

 // QR 코드 보기에서 생성되는 QR URL에 기본으로 추가하는 UTM

var QR_UTM = {
  utm_source: 'qr_code',
  utm_medium: 'offline',
  utm_campaign: 'qr_code'
};
/**
 * 대량발송용 공유 링크 URL을 QR 전용 URL로 변환한다.
 * - 기존 URL에 있던 모든 utm_* 파라미터는 제거하고 QR 기본 UTM으로 대체한다.
 * - utm 외 다른 쿼리 파라미터(foo=bar 등)는 그대로 유지한다.
 * - utm_content는 추가하지 않는다.
 */

var createQrShareUrl = function createQrShareUrl(shareUrl) {
  var url = new URL(shareUrl);
  Array.from(url.searchParams.keys()).filter(function (key) {
    return key.startsWith('utm_');
  }).forEach(function (key) {
    return url.searchParams["delete"](key);
  });
  Object.entries(QR_UTM).forEach(function (_ref) {
    var _ref2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    url.searchParams.set(key, value);
  });
  return url.toString();
};
/**
 * 공유 링크가 열릴 뷰어 origin. 기존 get*ShareLink 들과 같은 호스트 분기를 따른다.
 */

var getViewerOrigin = function getViewerOrigin(_ref3) {
  var domain = _ref3.domain;
  var hostname = window.location.hostname; // CASE1. 유저가 세팅한 커스텀 도메인이 있는 경우

  if (domain && domain !== null) {
    return "https://".concat(domain);
  } // CASE2. alpha.salesclue.io인 경우


  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.release */ .y.I.release)) {
    return "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.release */ .y.a.release);
  } // CASE3. app.salesclue.io인 경우


  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.main */ .y.I.main)) {
    return "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.main */ .y.a.main);
  } // CASE4. 로컬 개발 중일 때


  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.local */ .y.I.local)) {
    return 'http://localhost:3002';
  } // CASE5. dev환경일 때


  return "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.dev */ .y.a.dev);
};
/**
 * 단축 공유 링크. 기존 /share/... URL과 동시에 유효하다.
 */

var getShortShareLink = function getShortShareLink(_ref4) {
  var token = _ref4.token,
      domain = _ref4.domain;
  return "".concat(getViewerOrigin({
    domain: domain
  }), "/s/").concat(token);
};
/**
 * ESP 머지태그(`?email=$%email%$` 등)처럼 `?`로 시작하는 접미사를 URL에 붙인다.
 * 머지태그는 인코딩되면 안 되므로 URL 파서를 쓰지 않고 문자열로 결합하되,
 * 이미 쿼리가 있는 URL이면 `?`를 `&`로 바꿔 깨지지 않게 한다.
 */

var appendQuerySuffix = function appendQuerySuffix(url, suffix) {
  if (!suffix) {
    return url;
  }

  if (url.includes('?') && suffix.startsWith('?')) {
    return "".concat(url, "&").concat(suffix.slice(1));
  }

  return "".concat(url).concat(suffix);
};
var getFileShareLink = function getFileShareLink(_ref5) {
  var hashId = _ref5.hashId,
      isBulk = _ref5.isBulk,
      domain = _ref5.domain;
  var hostname = window.location.hostname; //CASE1. 유저가 세팅한 커스텀 도메인이 있는 경우

  if (domain && domain !== null) {
    var _shareLink = isBulk ? "https://".concat(domain, "/share/bulk/file/").concat(hashId) : "https://".concat(domain, "/share/file/").concat(hashId);

    return _shareLink;
  } // CASE2. alpha.salesclue.io인 경우


  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.release */ .y.I.release)) {
    var _shareLink2 = isBulk ? "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.release */ .y.a.release, "/share/bulk/file/").concat(hashId) : "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.release */ .y.a.release, "/share/file/").concat(hashId);

    return _shareLink2;
  } // CASE3. app.salesclue.io인 경우


  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.main */ .y.I.main)) {
    var _shareLink3 = isBulk ? "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.main */ .y.a.main, "/share/bulk/file/").concat(hashId) : "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.main */ .y.a.main, "/share/file/").concat(hashId);

    return _shareLink3;
  } // CASE4. 로컬 개발 중일 때


  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.local */ .y.I.local)) {
    var _shareLink4 = isBulk ? "http://localhost:3002/share/bulk/file/".concat(hashId) : "http://localhost:3002/share/file/".concat(hashId);

    return _shareLink4;
  } // CASE5. dev환경일 때


  var shareLink = isBulk ? "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.dev */ .y.a.dev, "/share/bulk/file/").concat(hashId) : "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.dev */ .y.a.dev, "/share/file/").concat(hashId);
  return shareLink;
};
var getBulkLinkShareLink = function getBulkLinkShareLink(_ref6) {
  var slug = _ref6.slug,
      domain = _ref6.domain;
  var hostname = window.location.hostname;

  if (domain && domain !== null) {
    return "https://".concat(domain, "/share/bulk/link/").concat(slug);
  }

  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.release */ .y.I.release)) {
    return "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.release */ .y.a.release, "/share/bulk/link/").concat(slug);
  }

  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.main */ .y.I.main)) {
    return "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.main */ .y.a.main, "/share/bulk/link/").concat(slug);
  }

  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.local */ .y.I.local)) {
    return "http://localhost:3002/share/bulk/link/".concat(slug);
  }

  return "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.dev */ .y.a.dev, "/share/bulk/link/").concat(slug);
};
var getLinkShareLink = function getLinkShareLink(_ref7) {
  var hashId = _ref7.hashId,
      domain = _ref7.domain;
  var hostname = window.location.hostname;

  if (domain && domain !== null) {
    var _shareLink5 = "https://".concat(domain, "/share/link/").concat(hashId);

    return _shareLink5;
  }

  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.main */ .y.I.main)) {
    var _shareLink6 = "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.main */ .y.a.main, "/share/link/").concat(hashId);

    return _shareLink6;
  }

  if (hostname.includes(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.CLIENT.local */ .y.I.local)) {
    var _shareLink7 = "http://localhost:3002/share/link/".concat(hashId);

    return _shareLink7;
  }

  var shareLink = "https://".concat(_pairy_sheard_constants__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN.VIEWER.dev */ .y.a.dev, "/share/link/").concat(hashId);
  return shareLink;
};

/***/ })

}]);